module.exports = __webpack_public_path__ + "static/media/add_app_next.7e488fdd.png";